export { Qr as Qr1 } from "./Qr1";
export { Qr as Qr2 } from "./Qr2";